import Box from "../common/Box";
import Flex from "../common/Flex";
import Typography from "../common/Typography";
import data from "@/public/data/thirdparty/safarmarket.json";

interface SafarmarketProps {
  service?: TServices;
  className?: string;
}

export default function Safarmarket({
  service = "flight",
  className,
}: SafarmarketProps) {
  const { prefix, name, suffix } = data;

  return (
    <Flex
      className={`w-full md:w-auto items-center justify-center p-1 gap-x-2 max-md:mt-2 px-6 mx-auto bg-orange-500 rounded-xs text-background ${className}`}
    >
      <Typography
        variant="body1"
        className="font-normal max-sm:text-xs min-w-max"
      >
        {prefix}
      </Typography>
      <Box className="p-1 bg-background rounded-xs">
        <Typography
          variant="body1"
          className="text-orange-600 font-normal max-sm:text-xs"
        >
          {name}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        className="font-normal max-sm:text-xs  min-w-max"
      >
        {suffix}
      </Typography>
    </Flex>
  );
}
